/* eslint-disable single-export/single-export */
/* eslint-disable @typescript-eslint/member-ordering */

import { Observable } from 'rxjs';

import { ServerResponse } from './server-response';

export interface ListViewFilters {
  searchTerm: string;
  pageIndex: number;
  pageSize: number;

  sortColumn: string;
  sortDescending: boolean;
}

export interface ListViewResults<T> {
  data: T[];
  dataCount: number;
}

export interface ListViewSettings {
  // General
  isGalleryDefault?: boolean;
  allowCreate?: boolean;
  createButtonText?: string;
  allowEdit?: boolean;

  // Gallery
  allowGalleryMode?: boolean;
  gallerySettings?: ListViewGallerySettings;

  // Table
  allowTableMode?: boolean;
  tableSettings?: ListViewTableSettings;
  showActiveState?: boolean;

  // Search
  hideSearch?: boolean;
  searchPlaceholder?: string;

  // Sort
  defaultSortColumn: string;
  defaultSortDirection?: string;

  // Data
  getData: (filters: ListViewFilters) => Observable<ServerResponse<ListViewResults<unknown>>>;
  create?: () => Observable<boolean>;
  edit?: (item: unknown) => Observable<boolean>;
  syncIntegrationData: (storeId: string) => void;
}

export interface ListViewGallerySettings {
  createButtonImage?: string;
  imageProperty?: string;
  linkFunc?: (item: unknown) => unknown[];
  nameProperty: string;
}

export interface ListViewTableSettings {
  columns: ListViewTableColumn[];
  showExpand?: boolean;
}

export enum ListViewTableColumnType {
  Text = 1,
  Boolean = 2,
  DateTime = 3,
  Date = 4,
  Image = 6,
}

export interface ListViewTableColumn {
  allowSort?: boolean;
  columnType: ListViewTableColumnType;
  displayText: string;
  emptyText?: string;
  linkFunc?: (item: unknown) => unknown[];
  name: string;
  parser?: (item: unknown) => unknown;
}

export type ListViewRow = Record<string, unknown>;
